<template>
  
  <v-list dense>

    <!-- Back -->
    <v-list-item @click="$emit('back')">
      <v-list-item-icon>
        <v-icon disabled>mdi-chevron-left</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Audio Tracks</v-list-item-title>  
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list-item-group
      mandatory
      :value    = "currentAudioTrack"
      @change   = "onSetAudioTrack"
    >

      <v-list-item
        v-for   = "(track, index) in tracks"
        color   = "primary"
        :key    = "index"
        :value  = "index"
      >
        <v-list-item-content>
          <v-list-item-title v-if="track.description">{{ track.description }}</v-list-item-title>
          <v-list-item-title v-else>Track {{ track.track + 1 }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

    </v-list-item-group>

  </v-list>

</template>

<script lang="js">

// #region Imports

/* vuex */
import { mapState } from 'vuex';

/* Telestream */
import { SELECT_AUDIO_TRACK, MODIFY_AUDIO_SOUND_FIELD } from '@/utils/action-types';

// #endregion Imports

export default {

  // #region Properties

  name:     'AudioTracksMenu',
  computed: {

    ...mapState([
      'videoController'
    ]),

    tracks() {
      if (!this.videoController) {
        return [];
      }

      return this.videoController.audioTracksList;
    },

    currentAudioTrack() {
      if (!this.videoController || !this.videoController.currentAudioTrack) {
        return undefined;
      }

      return this.videoController.currentAudioTrack.track;
    }

  },

  // #endregion Properties

  // #region Events

  methods: {

    onSetAudioTrack(index) {
      this.$store.dispatch(SELECT_AUDIO_TRACK, index);
      if(this.videoController.currentAudioTrack.soundfields.has('Surround')) {
        this.$store.dispatch(
          MODIFY_AUDIO_SOUND_FIELD,
          {
            soundField: 'Surround'
          }
        );
      }
    }

  }

  // #endregion Events

}

</script>